import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminPage from "@/pages/AdminPage";
import PrivacyPage from "@/pages/PrivacyPage";
import { goToTesterSignup } from "@/lib/site";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Features } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Screens } from "@/components/landing/Screens";
import { Showcase } from "@/components/landing/Showcase";
import { Banner } from "@/components/landing/Banner";
import { Manifesto } from "@/components/landing/Manifesto";
import { Testimonials } from "@/components/landing/Testimonials";
import { Pricing } from "@/components/landing/Pricing";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";

function Landing() {
  const [fromTester] = useState(() => new URLSearchParams(window.location.search).get("tester") === "1");
  useEffect(() => {
    if (!fromTester) return undefined;
    window.history.replaceState(null, "", "/");
    const t = setTimeout(goToTesterSignup, 700);
    return () => clearTimeout(t);
  }, [fromTester]);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Showcase />
        <Features />
        <HowItWorks />
        <Screens />
        <Manifesto />
        <Testimonials />
        <Pricing />
        <Faq />
        <Banner />
        <FinalCta />
      </main>
      <Footer />
    </>
  );
}

function TesterLanding() {
  useEffect(() => {
    const t = setTimeout(goToTesterSignup, 700);
    return () => clearTimeout(t);
  }, []);
  return <Landing />;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0e0f12] text-[#f2f3f5] overflow-x-clip">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/test" element={<TesterLanding />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
